var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        ref: "ctomissTab",
        attrs: {
          type: "horizon",
          inlineLabel: true,
          dense: true,
          height: _vm.tabHeight,
          tabItems: _vm.tabItems,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  key: tab.key,
                  tag: "component",
                  attrs: {
                    tabParam: _vm.tabParam,
                    attachInfo: _vm.attachInfo,
                    contentHeight: _vm.contentHeight,
                  },
                  on: {
                    "update:tabParam": function ($event) {
                      _vm.tabParam = $event
                    },
                    "update:tab-param": function ($event) {
                      _vm.tabParam = $event
                    },
                    "update:attachInfo": function ($event) {
                      _vm.attachInfo = $event
                    },
                    "update:attach-info": function ($event) {
                      _vm.attachInfo = $event
                    },
                    changeStatus: _vm.changeStatus,
                    getDetail: _vm.getDetail,
                    closePopup: _vm.closePopup,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }